import { FileSizeFormat } from '@shared/utils/enums';

const sizeUnits: Record<FileSizeFormat, number> = {
  [FileSizeFormat.B]: 1,
  [FileSizeFormat.KB]: 1000,
  [FileSizeFormat.MB]: 1000 ** 2,
};

export const convertToFileSizeFormat = (size: number, sizeFormat: FileSizeFormat, targetFormat: FileSizeFormat): number => {
  if (!sizeUnits[sizeFormat] || !sizeUnits[targetFormat]) {
    throw new Error('Invalid file size format');
  }

  const sizeInBytes = size * sizeUnits[sizeFormat];
  return sizeInBytes / sizeUnits[targetFormat];
};
